import { render, staticRenderFns } from "./UploadCompleted.vue?vue&type=template&id=2af56c3e&scoped=true"
import script from "./UploadCompleted.vue?vue&type=script&lang=js"
export * from "./UploadCompleted.vue?vue&type=script&lang=js"
import style0 from "./UploadCompleted.vue?vue&type=style&index=0&id=2af56c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af56c3e",
  null
  
)

export default component.exports